import { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'
import { getEmarConfirmProps } from '../components/getEmarConfirmProps'

interface EmarRouteFieldProps {
  fields: Record<string, any>
  formId: string
  onChange: (value: string) => void
  requireConfirm: boolean
}

/**
 * @description Renders EmarRouteField for the Add Medication modal
 * @param {EmarRouteFieldProps} props - The component's props.
 * @returns {JSX.Element} EmarRouteField.
 */
export default function EmarRouteField(
  props: EmarRouteFieldProps
): JSX.Element {
  const { fields, formId, onChange, requireConfirm } = props

  const confirmInputStyle = requireConfirm ? styles.prepopField : null

  return (
    <div style={styles.fieldSubContainer}>
      <Suspense fallback={<div>Loading...</div>}>
      <Field
        confirmInputStyle={styles.prepopField}
        confirmProps={{
          confirmInputStyle,
          ...getEmarConfirmProps(),
        }}
        format
        formId={formId}
        keys="route"
        label="Route"
        labelStyle={styles.routeLabel}
        layout="column"
        onChange={onChange}
        requireConfirm={requireConfirm}
        type="text"
        values={fields}
      />
      </Suspense>
    </div>
  )
}

const styles = {
  buttonIcon: {
    fontSize: 14,
  },
  fieldSubContainer: {
    borderRadius: 15,
    padding: 16,
    marginBottom: 16,
    background: colors.white,
  },
  prepopField: {
    background: colors.hoverblue,
  },
  routeLabel: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: '22px',
    marginBottom: 16,
  },
  text: {
    lineHeight: '22px',
  },
}
